module.exports = __webpack_public_path__ + "img/BlinkArt_Sword13_Green.35cb69a7.png";